const artifactIdRgx = /services\/+(.+?)\//

export function extractArtifactIdFromScriptUrl(scriptUrl: string | undefined | null) {
	if (scriptUrl == null) {
		return null
	}
	return artifactIdRgx.exec(scriptUrl)?.[1]
}
